module.exports = __webpack_public_path__ + "media/images/about-pic1-bf050ba4.png";